import React from 'react';
import { connect } from 'react-redux';
import { StoreState } from '../../../../redux/reducers/store.types';
import { MaybeUndef } from '../../../../types/system';
import { memoizedPartial } from '../../../../utils/function/memoized-partial';
import { toggleOpen } from '../accordion.actions';
import { getAccordionState } from '../accordion.selectors';
import { Collapsible } from '../collapsible/collapsible';

interface OwnProps {
  id: string;
  title: React.ReactNode;
  onCloseClick(): void;
  children: React.ReactNode;
}

interface StateProps {
  openedItemKey: MaybeUndef<string>;
}

interface DispatchProps {
  toggleOpen(key: string): void;
}

type Props = OwnProps & StateProps & DispatchProps;

export const AccordionItem: React.FunctionComponent<Props> = ({
  id,
  openedItemKey,
  children,
  onCloseClick,
  title,
  toggleOpen,
}: Props) => (
  <Collapsible
    isCollapsed={openedItemKey !== id}
    onCloseClick={onCloseClick}
    onToggleCollapseClick={memoizedPartial(toggleOpen, id)}
    title={title}
  >
    {children}
  </Collapsible>
);

const mapStateToProps = (state: StoreState) => ({
  openedItemKey: getAccordionState(state).openedItemKey,
});

const mapDispatchToProps = {
  toggleOpen,
};

export const AccordionItemContainer = connect<
  StateProps,
  DispatchProps,
  OwnProps
>(
  mapStateToProps,
  mapDispatchToProps,
)(AccordionItem);
